module.exports = __webpack_public_path__ + "static/media/IMG_0338.1352f5e1.JPG";